import React from "react";
import type { LinkProps } from "ui/components/Link";
import Link from "ui/components/Link";
import cx from "ui/cx";
import IconChevron from "ui/icons/IconChevron";
import styles from "./BreadcrumbMenu.module.scss";

export type Breadcrumb = {
  text: string;
} & LinkProps;

const BreadcrumbMenu = ({ breadcrumbs, className }: { breadcrumbs: Breadcrumb[]; className?: string }) => {
  return (
    <div className={cx(styles.breadcrumbMenu, className)}>
      {breadcrumbs.map(({ text, ...props }, i) => (
        <React.Fragment key={`breadcrumb-nav-text-${i}`}>
          <Link {...props}>{text}</Link>
          {i < breadcrumbs.length - 1 && <IconChevron size={8} className={styles.chevron} />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default BreadcrumbMenu;
